import { render, staticRenderFns } from "./Omelette.vue?vue&type=template&id=73e9621f&scoped=true"
import script from "./Omelette.vue?vue&type=script&lang=js"
export * from "./Omelette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e9621f",
  null
  
)

export default component.exports